"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoFlightsAvailable = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'reservation-no-flights-available';
const NoFlightsAvailable = (props) => {
    const { modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/NoFlightsAvailable:message', defaultMessage: 'No flights available' })));
};
exports.NoFlightsAvailable = NoFlightsAvailable;
//# sourceMappingURL=index.js.map